module.exports = __webpack_public_path__ + "assets/img/shell.86c8c894.png";